var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9V12.75C16.5 15 15 16.5 12.75 16.5H5.25C3 16.5 1.5 15 1.5 12.75V9C1.5 6.96 2.73 5.535 4.6425 5.295C4.8375 5.265 5.04 5.25 5.25 5.25H12.75C12.945 5.25 13.1325 5.25749 13.3125 5.28749C15.2475 5.51249 16.5 6.945 16.5 9Z",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3136 5.2875C13.1336 5.2575 12.9461 5.25001 12.7511 5.25001H5.25105C5.04105 5.25001 4.83855 5.26501 4.64355 5.29501C4.74855 5.08501 4.89855 4.89001 5.07855 4.71001L7.51606 2.265C8.54356 1.245 10.2086 1.245 11.2361 2.265L12.5486 3.59251C13.0286 4.06501 13.2836 4.665 13.3136 5.2875Z",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9.375H14.25C13.425 9.375 12.75 10.05 12.75 10.875C12.75 11.7 13.425 12.375 14.25 12.375H16.5",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPay);
export default __webpack_public_path__ + "static/media/pay.464eb4457581f2624dcb3cfc6097a971.svg";
export { ForwardRef as ReactComponent };